import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import Swal from 'sweetalert2';
import POAMView from './AraiManufacturing/View';
import POPIView from './PumpSpareInternational/View';

function PoView() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [potype, setpotype] = useState('');
  const [pocategory, setpocategory] = useState('');
  const [poData, setPoData] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}purchaseOrder/findById/${id}`, {
          headers: authHeader(),
        });
        setPoData(response.data);
        setpotype(response.data.potype);
        setpocategory(response.data.pocategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (potype === 'Pump Spare' && pocategory === 'International') {
      return <POPIView />;
    } else if (potype === 'Manufacturing') {
      return <POAMView />;
    }
    return null; // Default fallback
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}purchaseOrder/poCancelStatus/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          navigate(`/poindex/${pointindex}`);
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  async function cancelHandler() {
    try {
      await axios.get(`${BASE_URL}purchaseOrder/poCancelStatus/${id}`, {
        headers: authHeader(),
      });
      navigate(`/poindex/${pointindex}`);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>VIEW-PO</h6>
          <div>
            <strong>Type:</strong> {potype} | <strong>Category:</strong> {pocategory}
          </div>
          <div className="view-buttons">
            {pocategory === "Domestic" && potype === "Manufacturing" && poData?.status === "Open" && (
              <Link to={`/purchase-order-to-inspection-convert/${id}`}>
                <button className="button-70">Convert To Inspection</button>
              </Link>
            )}

            {pocategory === "International" && poData?.status === "Open" && (
              <Link to={`/purchase-order-to-grn-convert/${id}`}>
                <button className="button-70">Convert To GRN</button>
              </Link>
            )}

            {poData?.status === "Open" && poData?.status !== "Cancelled" && (
              <Link to={`/poEdit/${id}/${pointindex}`}>
                <button className="button-70">EDIT</button>
              </Link>
            )}

            {poData?.status === "Open" && poData?.status !== "Cancelled" && (
              <button className="button-70" onClick={cancelHandler}>
                Cancel
              </button>
            )}

            <Link to={`/poindex/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        {renderPageDisplay()}
      </Card>
    </div>
  );
}

export default PoView;
